import React from 'react'

import './date-picker.scss'

const DatePicker = () => {
  let id
  return (
    <input className="input" type="date" name={id + 'Name'} id={id} />
  )
}

export default DatePicker
